module.exports = __webpack_public_path__ + "img/member-card.fcc6ca32.png";